module.exports = __webpack_public_path__ + "img/bio-purple-6.d1817e4.jpg";